import { InfluencerCampaign } from '../../Apps/Shared/NewCampaigns/InfluencerCampaigns/types';

export interface InfluencerCampaignState {
    influencerCampaign: InfluencerCampaign;
    isLoading: boolean;
    error: string;
}

export const SET_INFLUENCER_CAMPAIGN = 'SET_INFLUENCER_CAMPAIGN';

export const SET_LOADING = 'SET_LOADING';

export const SET_ERROR = 'SET_ERROR';

interface SetInfluencerCampaignAction {
    type: typeof SET_INFLUENCER_CAMPAIGN;
    payload: InfluencerCampaign;
}

interface SetLoadingAction {
    type: typeof SET_LOADING;
    payload: boolean;
}

interface SetErrorAction {
    type: typeof SET_ERROR;
    payload: string;
}

export type InfluencerCampaignActionTypes =
    | SetInfluencerCampaignAction
    | SetLoadingAction
    | SetErrorAction;
